import { createFileRoute, redirect } from '@tanstack/react-router';

import { riskQueries } from '@repo/api/risk/risks';
import { isValidPage, NOPRForm, Page } from '@repo/features/nopr';

import { Route as RiskRoute } from '../_risk';
import { Route as DocumentsRoute } from '../_risk/documents';

export const Route = createFileRoute('/_risks/risk/$riskId/(nopr)/edit/$page')({
	beforeLoad: ({ context }) => {
		if (!context.user?.permissions.includes('risk.edit')) {
			throw redirect({
				to: '/',
			});
		}
	},
	loader: ({ context, params }) => {
		void context.queryClient.ensureQueryData(riskQueries.id(params.riskId));
	},
	component: function EditRiskPage() {
		const { page: pageParam, riskId } = Route.useParams();

		const page: Page = isValidPage(pageParam) ? pageParam : 'insured';

		const navigate = Route.useNavigate();

		const navigateToPage = async (targetPage?: Page, scrollKey?: string) => {
			if (targetPage && page !== targetPage) {
				await navigate({
					to: Route.to,
					params: (params) => ({
						...params,
						page: targetPage,
					}),
				});
			}

			if (scrollKey) {
				document.getElementById(scrollKey)?.scrollIntoView({
					behavior: 'smooth',
					block: 'center',
				});
			}
		};

		return (
			<NOPRForm
				key={riskId}
				riskId={riskId}
				page={page}
				navigateToPage={navigateToPage}
				exit={(source?: 'submit' | 'save') => {
					return navigate({
						to: source === 'submit' ? DocumentsRoute.to : RiskRoute.to,
					});
				}}
				title="Edit Risk"
			/>
		);
	},
	head: (ctx) => ctx.match.context.setTitle('Risk', 'Edit'),
});
